import {
  WBS_SAVE_DELIVERABLE_BEGIN,
  WBS_SAVE_DELIVERABLE_SUCCESS,
  WBS_SAVE_DELIVERABLE_FAILURE,
  WBS_SAVE_DELIVERABLE_DISMISS_ERROR,
} from './constants';



import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';
import {CREATE_PROJECT_MODEL_ACTION_CREATE} from '../../common/redux/constantes';


// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function saveDeliverable(deliverable, action, args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: WBS_SAVE_DELIVERABLE_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let URL = SERVER_PATH + '/deliverables';
      if(action === CREATE_PROJECT_MODEL_ACTION_CREATE)
      {
        deliverable.deliverable = 0;
        URL+="/create";
      }
      else
      {
        URL+="/edit";
      }

      axios.post(URL, {
        deliverable:deliverable
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          if(res.data.success===1)
          {
            dispatch({
              type: WBS_SAVE_DELIVERABLE_SUCCESS,
              data: res,
            });
            resolve(res);
          }else
          {
            dispatch({
              type: WBS_SAVE_DELIVERABLE_FAILURE,
              data: { error: "Internal error" },
            });
            reject("err");
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: WBS_SAVE_DELIVERABLE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSaveDeliverableError() {
  return {
    type: WBS_SAVE_DELIVERABLE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case WBS_SAVE_DELIVERABLE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        saveDeliverablePending: true,
        saveDeliverableError: null,
      };

    case WBS_SAVE_DELIVERABLE_SUCCESS:
      // The request is success
      return {
        ...state,
        saveDeliverablePending: false,
        saveDeliverableError: null,
        openSnackBar:true,
        messageSnackBar:'Deliverable saved'
      };

    case WBS_SAVE_DELIVERABLE_FAILURE:
      // The request is failed
      return {
        ...state,
        saveDeliverablePending: false,
        saveDeliverableError: action.data.error,
        openSnackBar:true,
        messageSnackBar:'Internal error'
      };

    case WBS_SAVE_DELIVERABLE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        saveDeliverableError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/wbs/redux/saveDeliverable.js